import { ImageLoaderProps } from 'next/image';

const FIXED_PREVIEW_WIDTH = 800;
const DEFAULT_PREVIEW_QUALITY = 75;

export const fixed800Loader = ({ src, quality }: ImageLoaderProps): string => {
  const params = new URLSearchParams({
    url: src,
    w: String(FIXED_PREVIEW_WIDTH),
    q: String(quality ?? DEFAULT_PREVIEW_QUALITY),
  });

  return `/_next/image?${params.toString()}`;
};
